module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="freeCancellation__inscription-container js-open-info-freeCancellation">\r\n	<div class="freeCancellation__inscription-icon"></div>\r\n	<div class="freeCancellation__inscription-content ">Бесплатная отмена</div>\r\n	<div class="freeCancellation__inscription-hintIcon"></div>\r\n</div>\r\n';
}
return __p;
};
